import {SearchParamsInterface} from "../interface/SearchParamsInterface";
import {useMutation, UseMutationResult} from "@tanstack/react-query";
import configAxios from "../configuration/configAxios";
import {interceptorResponse} from "../../utils/decode/decoding";
import {errorHandlerServices, getError} from "../configuration/errorHandle";
import {SIZE_PAGINATION} from "../../conf";
import {msjLine} from "../../layouts/components/InfoOnline";

export const findCurrentAdministrators = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/administrators`,
        {
            identifier: data.identifier,
            page: data.page,
            size: SIZE_PAGINATION
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp = interceptorResponse(response.data.object)
            if (resp === null) {
                msjLine()
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/administrators', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/administrators`);
    })
}

export const useFindCurrentAdministrators = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findCurrentAdministrators(data),
    });
}

export const findPreviousAdministrators = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pn_previous_administrators`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pn_previous_administrators', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pn_previous_administrators`);
    })
}

export const useFindPreviousAdministrators = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findPreviousAdministrators(data),
    });
}

export const findShareholders = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/shareholders`,
        {
            identifier: data.identifier,
            page: data.page,
            size: SIZE_PAGINATION
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            const resp = interceptorResponse(response.data.object)
            if (resp === null) {
                msjLine()
            }
            return resp
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/shareholders', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/shareholders`);
    })
}

export const useFindShareholders = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findShareholders(data),
    });
}

export const findLegalActs = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/legal_acts`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/legal_acts', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/legal_acts`);
    })
}

export const useFindLegalActs = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findLegalActs(data),
    });
}

export const findComplianceConsultation = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/compliance`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/compliance', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/compliance`);
    })
}

export const useFindComplianceConsultation = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findComplianceConsultation(data),
    });
}

export const findpaidValues = async (data: SearchParamsInterface) => {
    return await configAxios.post(
        `/pj_information/paid_values`,
        {
            identifier: data.identifier
        }
    ).then((response) => {
        if (response.data.status !== 1) {
            throw new Error(response.data.message);
        } else {
            return interceptorResponse(response.data.object)
        }
    }).catch(error => {
        errorHandlerServices(error, true, '/pj_information/paid_values', undefined, data?.msj)
        getError(error,
            error?.response?.data?.message ?
                error?.response?.data?.message : `Error service: /pj_information/paid_values`);
    })
}

export const useFindpaidValues = (): UseMutationResult<any, Error, any, unknown> => {
    return useMutation({
        mutationFn: (data: SearchParamsInterface) => findpaidValues(data),
    });
}
